import React, { FC, Fragment } from 'react';
import { Organization } from 'models/organization';
import { User } from 'models/user';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ActiveIndicator from 'components/users/shared/active-indicator/active-indicator.component';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { resolveUserOrganization } from 'utils/user-organization';

type DentistItemProps = {
    dentist: User;
    onUpdateDentist: (dentist: User) => void;
};

const DentistItem: FC<DentistItemProps> = ({ dentist, onUpdateDentist }: DentistItemProps) => {
    const currentOrg = currentOrgVar();
    const { t: translate } = useTranslation('common');
    // Derived rather than held in state — see technicians-item for why.
    const userOrganization = resolveUserOrganization(dentist, currentOrg._id);

    return (
        <Fragment>
            <TableRow
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => onUpdateDentist(Object.assign({}, dentist, userOrganization))}
            >
                <Fragment>
                    <TableCell sx={{ width: 10 }} align="center">
                        <ActiveIndicator isActive={!!userOrganization?.active} />
                    </TableCell>
                    <TableCell sx={{ width: 300 }}>
                        {dentist.name.firstName} {dentist.name.lastName}
                    </TableCell>
                    <TableCell>{dentist.email}</TableCell>
                    <TableCell>{translate(userOrganization.role)}</TableCell>
                    <TableCell>{(userOrganization.organization as Organization)?.name}</TableCell>
                </Fragment>
            </TableRow>
        </Fragment>
    );
};

export default DentistItem;
